import { render, staticRenderFns } from "./AddColumnLeft.vue?vue&type=template&id=737033db&"
import script from "./AddColumnLeft.vue?vue&type=script&lang=js&"
export * from "./AddColumnLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports